/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQueryClassification extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQueryClassification");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQueryClassification.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQueryClassification>): AutomationTemplateQueryClassification {
        let obj = Object.assign(new AutomationTemplateQueryClassification(), model);
        AutomationTemplateQueryClassification.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQueryClassification>): AutomationTemplateQueryClassification {
        if (!model) return null;
        return AutomationTemplateQueryClassification.newInstance(<AutomationTemplateQueryClassification> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQueryClassification) {
        if (!obj) return;

        models.AutomationTemplateQueryClassification.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQueryClassification): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQueryClassification.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template classifications to include
     */
    classifications: Array<string>;

}
